import React, { useEffect, useState } from "react"; 
import {
  CircularProgress,
  Grid,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import { Box } from "@mui/material";
import axios from "axios";
import { useSnackbar } from "notistack";
import { Link } from "react-router-dom";
import GenreList from "./GenreList";
import ContentRatingList from "./ContentRatingList";
import Header from "./Header";
import "./Home.css";
import endpoint from "../config";
import VideoCard from "./VideoCard";


const Home=()=>{
  const allGenres = [
      { label: "All", value: "All" },
      { label: "Education", value: "Education" },
      { label: "Sports", value: "Sports" },
      { label: "Comedy", value: "Comedy" },
      { label: "Lifestyle", value: "Lifestyle" },
      { label: "Movies", value: "Movies" },
    ];
  const allContentRatings = [
      { label: "All Age Group", value: "Anyone" },
      { label: "7+", value: "7%2B" },
      { label: "12+", value: "12%2B" },
      { label: "16+", value: "16%2B" },
      { label: "18+", value: "18%2B" },
    ];
  
    const { enqueueSnackbar } = useSnackbar();
    const [timerId, setTimerId] = useState(null);
    const [searchValid, setIfSearchValid] = useState("true");
    const [videos, setVideos] = useState([]);
    const [genres, setGenres] = useState(["All"]);
    const [selectedContentRatings, setSelectedContentRatings] = useState(
      "Anyone"
    );
    const [isLoading, setLoading] = useState(false);

    const performAPICall = async (URL) => {
      // console.log(URL);
      setLoading(true);
      try {
        const response = await axios.get(URL);
        console.log(response.data);
        setVideos(response.data.videos);
        setLoading(false);
        // setIfSearchValid(true)
      } catch (e) {
        if (e.response && e.response.data.message) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
        } else {
          enqueueSnackbar("Something went wrong", { variant: "error" });
        }
        setLoading(false);
        // setIfSearchValid(false)
      }
    };

    const performSearch = async (value, genres, selectedContentRatings) => {
      let URL = `${endpoint}?`;
      if (value.length) {
        URL += `title=${value}`;
      }
      if (genres.length) {
        if (genres.length && !genres.includes("All")) {
          const param = genres.join(",");
          URL[URL.length - 1] === "?"
            ? (URL += `genres=${param}`)
            : (URL += `&genres=${param}`);
        }
      }
      if (selectedContentRatings.length && selectedContentRatings !== "Anyone") {
        URL[URL.length - 1] === "?"
          ? (URL += `contentRating=${selectedContentRatings}`)
          : (URL += `&contentRating=${selectedContentRatings}`);
      }
      //console.log(URL);
      performAPICall(URL);
    };

    const debounceSearch = (event, debounceTimeout) => {
      const value = event.target.value;
      if (timerId) {
        clearTimeout(timerId);
      }
      const debounceTimeoutId = setTimeout(
        () => performSearch(value, genres, selectedContentRatings),
        debounceTimeout
      );
      setTimerId(debounceTimeoutId);
    };
  

    const handleGenreChange = (genre) => {
      const all = "All";
      const newGenreValue = genre.value;
      if (newGenreValue === all) {
        setGenres([all]);
      } else {
        //return us the array of genres without "All" in it
        const genreWithoutAll = genres.filter((item) => item !== all);
        let nextGenres;
        if (genreWithoutAll.includes(newGenreValue)) {
          nextGenres = genreWithoutAll.filter((ele) => ele !== newGenreValue);
       } else {
         nextGenres = [...genreWithoutAll, newGenreValue];
       }
       if (nextGenres.length === 0) {
        setGenres([all]);
       } else {
         setGenres(nextGenres);
       }
      }
    };

    const handleContentRatingChange = (contentRating) => {
      setSelectedContentRatings(contentRating.value);
    };

    useEffect(() => {
      const URL = endpoint;
      performAPICall(URL);
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      performSearch("", genres, selectedContentRatings);
      // eslint-disable-next-line
    }, [genres, selectedContentRatings]);

  return (
    <>
      <Box className="header-box" sx={{ height: "10vh", bgcolor: "#202020" }}>
        <Header
          fetchVideos={performAPICall}
          genres={allGenres}
          contentRatings={allContentRatings}
        >
        {/* Search view for desktop */}
          <TextField
            className="search-desktop"
            size="small"
            inputProps={{ style: { fontFamily: "Arial", color: "white" } }}
            InputProps={{
              className: "search",
              endAdornment: (
                <InputAdornment position="end">
                  <Search color="primary" />
                </InputAdornment>
              ),
            }}
            placeholder="Search"
            name="search"
            // value={search}
            // onChange={(e) => setSearch(e.target.value)}
            onChange={(event) => debounceSearch(event, 500)}
           />
        </Header>
      </Box>
  
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        inputProps={{ style: { fontFamily: "Arial", color: "white" } }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        onChange={(event) => debounceSearch(event, 500)}
        placeholder="Search"
        name="search"
        // value={search}
        // onChange={(e) => setSearch(e.target.value)}
      />
  
      <GenreList
        allGenres={allGenres}
        selectedGenres={genres}
        handleGenreChange={handleGenreChange}
        setVideos={setVideos}
      />
  
      <ContentRatingList
        allContentRatings={allContentRatings}
        selectedContentRatings={selectedContentRatings}
        handleContentRatingChange={handleContentRatingChange}
      />
  
      {searchValid ? (
        <Grid
          container
          paddingY="1rem"
          marginTop="0.6rem"
          paddingX="2rem"
          spacing={3}
        >
          {!isLoading ? (
            videos.map((video) => (
              <Grid item xs={12} sm={6} md={3} key={video._id}>
                <Link
                  to={`/video/${video._id}`}
                  className="video-tile-link"
                  style={{ textDecoration: "none", color: "white" }}
                >
                <VideoCard video={video} />
                </Link>
              </Grid>
            ))
          ) : (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            sx={{ height: "75vh", width: "100%" }}
          >
            <Box>
              <CircularProgress />
                {/* <p>Loading Videos...</p>  */}
            </Box>
          </Box>
          )}
        </Grid>
       ) : (
        <Box className="loading">
          <SentimentDissatisfied />
          <p>No videos found</p>
        </Box>
      )}
     </>
    );
}

export default Home;